import { render, staticRenderFns } from "./fixTarget.vue?vue&type=template&id=2a8506a6&"
import script from "./fixTarget.vue?vue&type=script&lang=js&"
export * from "./fixTarget.vue?vue&type=script&lang=js&"
import style0 from "./fixTarget.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports